import { Button, Flex } from '@chakra-ui/react';
import { useEffect } from 'react';

import Dialog from '@app/components/common/modals/dialog';
import { TextField } from '@app/components/common';
import { VisitFrequencySelectField } from '@app/components/common/visit-frequency';
import { useAlert, useEntityState } from '@app/hooks';
import { usePaginatedAutocomplete } from '@app/hooks/use-autocomplete';

import { RouteNumberField } from '../components/route-number-field';
import { OutletRouteForm } from '../types';

const emptyForm: OutletRouteForm = {
  visits_day: null,
  is_active: true,
};

export const OutletRouteDialog = ({
  isVisible,
  excludedRouteNumberIds = [],
  item,
  isEdit,
  onClose,
  onSave,
}: {
  isVisible: boolean;
  excludedRouteNumberIds?: number[];
  item?: OutletRouteForm;
  isEdit: boolean;
  onClose: () => void;
  onSave: (item: OutletRouteForm) => Promise<boolean>;
}) => {
  const [instance, onChange, setInstance] = useEntityState<OutletRouteForm>(emptyForm);
  const { error } = useAlert();
  const getPaginatedAutocomplete = usePaginatedAutocomplete();

  useEffect(() => {
    setInstance(item || emptyForm);
  }, [item]);

  const onSaveClick = async () => {
    if (!isEdit && !instance.route_number) {
      error('Выберите номер маршрута');
      return;
    }

    const isSaved = await onSave({
      is_active: true,
      ...instance,
      visits_day: instance.visits_day || null,
    });

    if (!isSaved) {
      return;
    }

    setInstance(emptyForm);
    onClose();
  };

  return (
    <Dialog
      open={isVisible}
      title={isEdit ? 'Редактирование маршрута' : 'Добавление маршрута'}
      onClose={onClose}
      actions={
        <Flex justifyContent="space-between" w="100%">
          <Button onClick={onSaveClick} variant="solid" colorScheme="brand">
            Сохранить
          </Button>
          <Button onClick={onClose}>Отмена</Button>
        </Flex>
      }
    >
      <Flex gap={4} alignItems="stretch" direction="column">
        {isEdit ? (
          <TextField
            value={instance.route_number?.name || ''}
            onChange={() => undefined}
            id="route_number"
            label="Номер маршрута"
            readOnly
          />
        ) : (
          <RouteNumberField
            required
            id="route_number"
            label="Номер маршрута"
            name="route_number"
            valueProperty="name"
            value={instance.route_number}
            onChange={(value) => {
              if (excludedRouteNumberIds.includes(Number(value?.id))) {
                error('Этот маршрут уже добавлен');
                return;
              }
              onChange('route_number')(value);
            }}
            onFetchOptions={getPaginatedAutocomplete}
          />
        )}
        <VisitFrequencySelectField
          id="visits_day"
          label="День визита в ТТ"
          value={instance.visits_day || ''}
          onChange={(value) => {
            onChange('visits_day')(value || null);
          }}
        />
      </Flex>
    </Dialog>
  );
};
